import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetAdministratorByFirebaseToken = async (
  firebaseToken,
  setLoading
) => {
  setLoading(true);
  try {
    const apiConfig = getApiConfig();
    const response = await axios.get(`${apiConfig.baseURL}/admins/token`, {
      headers: {
        Authorization: `Bearer ${firebaseToken}`,
        ...apiConfig.headers,
      },
    });
    return response.data?.data || null;
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response?.data || error.message
    );
    return null;
  } finally {
    setLoading(false);
  }
};

export const APIGetAdministrators = async (
  setLoading,
  pageNumber,
  searchTerm,
  institutionId
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/admins/`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        totalPerPage: 10,
        search: searchTerm,
        institutionId,
      },
    });

    return result;
  } catch (error) {
    console.error("Error fetching administrators:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIInviteAdministrators = async (
  adminData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.post(`${apiConfig.baseURL}/admins`, adminData, {
      headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
    });

    return result;
  } catch (error) {
    console.error("Error updating admin:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIUpdateAdministrators = async (
  adminId,
  setLoading,
  adminData,
  institutionId,
  token
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.patch(
      `${apiConfig.baseURL}/admins/${adminId}`,
      adminData,
      {
        headers: {
          ...apiConfig.headers,
          institutionId: institutionId,
          token: token
        },
        params: { institutionId: institutionId },
      }
    );

    return result;
  } catch (error) {
    console.error("Error updating admin:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIDeleteAdministrators = async (
  adminId,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.delete(
      `${apiConfig.baseURL}/admins/${adminId}`,
      {
        headers: {
          ...apiConfig.headers,
          institutionId: institutionId,
          token: token
        },
        params: { institutionId: institutionId },
      }
    );

    return result;
  } catch (error) {
    console.error("Error deleting admins:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
